import * as Yup from "yup";
import dayjs from "dayjs";

export const dynamicFieldValidationSchema: Record<string, Yup.AnySchema> = {
  campaignOwner: Yup.string().required("Campaign Owner cannot be empty"),
  type: Yup.string().required("Type cannot be empty"),
  description: Yup.string()
    .required("Description cannot be empty")
    .max(150, "Description cannot be more than 150 characters"),
  expectedResponse: Yup.string()
    .required("Expected Response cannot be empty")
    .max(50, "Expected Response cannot be more than 50 characters"),
  status: Yup.string().required("Status cannot be empty"),
  actualCost: Yup.string().required("Actual Cost cannot be empty"),
  budgetedCost: Yup.string().required("Budgeted Cost cannot be empty"),
  expectedRevenue: Yup.string().required("Expected Revenue cannot be empty"),
  startAndEndDate: Yup.object({
    startdate: Yup.mixed<dayjs.Dayjs>()
      .required("Start Date cannot be empty")
      .test("startdate-valid", "Please enter valid date", (value) => {
        return (
          value === null ||
          (dayjs(value).isValid() &&
            !dayjs(value).isBefore(dayjs("1900-01-01")))
        );
      })
      .test(
        "startdate-before-enddate",
        "Start date cannot be after end date",
        function (value) {
          const { enddate } = this.parent as any;
          if (value && enddate && value.isAfter(dayjs(enddate))) {
            return this.createError({
              path: "startdate",
              message: "Start date cannot be after end date",
            });
          }
          return true;
        }
      ),
    enddate: Yup.mixed<dayjs.Dayjs>()
      .required("End Date cannot be empty")
      .test("enddate-valid", "Please enter valid date", (value) => {
        return (
          value === null ||
          (dayjs(value).isValid() &&
            !dayjs(value).isBefore(dayjs("1900-01-01")))
        );
      })
      .test(
        "enddate-after-startdate",
        "End date cannot be before start date",
        function (value) {
          const { startdate } = this.parent as any;
          if (value && startdate && value.isBefore(dayjs(startdate))) {
            return this.createError({
              path: "enddate",
              message: "End date cannot be before start date",
            });
          }
          return true;
        }
      ),
  }),
};
